export default function faqService($http, RESOURCES) {
  function getFaqs(category, lang) {
    const params = {
      category: category,
      language: lang,
    };
    return $http.get(RESOURCES.FAQ, { params: params });
  }

  function updateFaq(category, lang, faqs) {
    const params = {
      category: category,
      language: lang,
    };
    return $http.put(
      RESOURCES.FAQ,
      {
        faqDtos: faqs,
      },
      { params: params },
    );
  }

  return { getFaqs: getFaqs, updateFaq: updateFaq };
}



// WEBPACK FOOTER //
// ./src/app/content-editor/bc/faq/faq.service.js